import styled from 'styled-components';

import { BackgroundSection, Container } from '@xing-com/layout-primitives';
import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  spaceM,
  spaceXL,
  spaceXXL,
  space4XL,
  space6XL,
} from '@xing-com/tokens';

export const Background = styled(BackgroundSection)`
  padding: 0;
`;

export const SearchBarContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};

  @media ${mediaWideNavless} {
    padding-top: ${spaceXL};
    padding-bottom: 55px;
  }
`;

export const SerpsContainer = styled(Container)`
  margin: ${space4XL} auto;
  padding: 0 20px;

  @media ${mediaConfined} {
    padding: 0 ${spaceXXL};
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${space4XL};
  margin-bottom: ${space6XL};
  padding: 0 20px;
`;
